import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { WorkbookAccelerationContentType } from '~src/ts/models/ContentTypes';
import { WorkbookAccelerations } from '~src/ts/resources/WorkbookAccelerations';

import { getNoDefaultFilters } from './getDefaultFilters';

export const WorkbookAccelerationDefinition: ExplorableItemDefinition = {
  itemType: 'workbookAcceleration',
  pluralName: Messages.workbookAccelerations,
  singularName: Messages.workbookAcceleration,
  emptyStateMessage: Messages.workbookAccelerationsEmptyMessage,
  contentFilterKeys: WorkbookAccelerationContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return WorkbookAccelerations.all().withExtraParams(WorkbookAccelerationContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
